import flatpickr from 'flatpickr';
import { German } from "flatpickr/dist/l10n/de.js";

export default class DatePicker {

	static init() {
		document.querySelectorAll('.date-picker').forEach((input) => {
			const date = input.value ?? input.getAttribute('value');
			const minDate = input.getAttribute('data-min-date');
			const maxDate = input.getAttribute('data-max-date');
			const inline = input.getAttribute('data-inline') == '1';
	
			let options = {
				locale: German,
				dateFormat: 'Y-m-d',
				disableMobile: true,
				inline: inline,
				altInput: true,
				altFormat: 'd.m.Y' 
			};
	
			if(minDate) options.minDate = minDate;
			if(minDate) options.maxDate = maxDate;
	
			const datePicker = flatpickr(input, options);
			if (date)
				datePicker.setDate(date);
		});
	}
}